import { Component, OnInit } from '@angular/core';
import { Logging } from '../../logging';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    Logging.log('Sidebar loaded');
  }

}



// WEBPACK FOOTER //
// ./src/app/client/sidebar/sidebar.component.ts